var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jiatingziranyuyanganyu"},[_c('PublicCert',{attrs:{"logo":_vm.Logo9,"type":'jy-nl',"color":'#3390cf'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }